export class CmsRenderStylesUtils {
    public static preloadStylesContainer(element) {
        const layout = element.definitionId;
        if (!element.settings) {
            return {
                styleLG: `@media screen and (min-width: 1280px) {}`,
                styleMD: `@media screen and (min-width: 992px) and (max-width: 1279px) {}`,
                styleSM: `@media screen and (min-width: 768px) and (max-width: 991px) {}`,
                styleXS: `@media screen and (max-width: 767px) {}`,
                default: '',
            };
        }

        const responsiveConfig = element.settings.styles.responsiveConfig;
        const childrenKeys = [];
        Object.keys(element.children).forEach(key => {
            childrenKeys.push(element.children[key][0]);
        });

        const parent = this.styleParentElement(element);

        const styleLG = this.structureElement(element, childrenKeys, responsiveConfig, '(min-width: 1280px)', layout);

        const styleMD = this.structureElement(element, childrenKeys, responsiveConfig, '(min-width: 992px)', layout);

        const styleSM = this.structureElement(element, childrenKeys, responsiveConfig, '(min-width: 768px)', layout);

        const styleXS = this.structureElement(element, childrenKeys, responsiveConfig, '(max-width: 767px)', layout);

        return {
            styleLG: `@media screen and (min-width: 1280px) {${parent.styleLG}${styleLG}}`,
            styleMD: `@media screen and (min-width: 992px) and (max-width: 1279px) {${parent.styleMD}${styleMD}}`,
            styleSM: `@media screen and (min-width: 768px) and (max-width: 991px) {${parent.styleSM}${styleSM}}`,
            styleXS: `@media screen and (max-width: 767px) {${parent.styleXS}${styleXS}}`,
            default: parent.style,
        };
    }

    public static styleParentElement(element) {
        let cssParent = [];
        // styles flex

        // flexbox
        const general = element.settings.general;
        if (general.alignContent) cssParent.push(`align-content: ${this.toFlex(general.alignContent)};`);
        if (general.alignItems) cssParent.push(`align-items: ${this.toFlex(general.alignItems)};`);
        if (general.flexDirection) cssParent.push(`flex-direction: ${this.toFlex(general.flexDirection)};`);
        if (general.flexWrap) cssParent.push(`flex-wrap: ${this.toFlex(general.flexWrap)};`);
        if (general.justifyContent) cssParent.push(`justify-content: ${this.toFlex(general.justifyContent)};`);

        // styles
        const styles = element.settings.styles;
        const styleParent = styles ? this.getStyles(styles) : [];
        const styleParentXS = styles.responsiveConfig ? this.getStyles(styles.responsiveConfig.find(config => config.id === '(max-width: 767px)')) : [];
        const styleParentSM = styles.responsiveConfig ? this.getStyles(styles.responsiveConfig.find(config => config.id === '(min-width: 768px)')) : [];
        const styleParentMD = styles.responsiveConfig ? this.getStyles(styles.responsiveConfig.find(config => config.id === '(min-width: 992px)')) : [];
        const styleParentLG = styles.responsiveConfig ? this.getStyles(styles.responsiveConfig.find(config => config.id === '(min-width: 1280px)')) : [];
        const id = `${element.definitionId}-${element.id.split('-')[0]}`;
        return {
            style: `#${id}{${cssParent.join('')} ${styleParent.join('')}}`,
            styleLG: `#${id}{${styleParentLG.join('')}}`,
            styleMD: `#${id}{${styleParentMD.join('')}}`,
            styleSM: `#${id}{${styleParentSM.join('')}}`,
            styleXS: `#${id}{${styleParentXS.join('')}}`,
        };
    }

    public static getStyles(styles: any = {}) {
        const style = [];
        if (styles.borderColor) style.push(`border-color: ${styles.borderColor};`);
        if (styles.borderRadius) style.push(`border-radius: ${styles.borderRadius};`);
        if (styles.borderStyle) style.push(`border-style: ${styles.borderStyle};`);
        if (styles.borderWidth) style.push(`border-width: ${styles.borderWidth};`);

        if (styles.marginBottom) style.push(`margin-block-end: ${styles.marginBottom};`);
        if (styles.marginLeft) style.push(`margin-inline-start: ${styles.marginLeft};`);
        if (styles.marginRight) style.push(`margin-inline-end: ${styles.marginRight};`);
        if (styles.marginTop) style.push(`margin-block-start: ${styles.marginTop};`);

        if (styles.paddingBottom) style.push(`padding-block-end: ${styles.paddingBottom};`);
        if (styles.paddingLeft) style.push(`padding-inline-start: ${styles.paddingLeft};`);
        if (styles.paddingRight) style.push(`padding-inline-end: ${styles.paddingRight};`);
        if (styles.paddingTop) style.push(`padding-block-start: ${styles.paddingTop};`);

        if (styles.bgColor) style.push(`background-color: ${styles.bgColor};`);

        return style;
    }

    public static structureElement(element, childrenKeys, responsiveConfig, breakpoint: string, layout: string = 'layout-full-width') {
        const config = responsiveConfig?.find(_config => _config.id === breakpoint);
        const structures = config?.structure ?? [];
        const structure = structures?.length > 0 ? structures[0] : ['1'];
        const cssChilds = [];
        // styles slots
        childrenKeys.forEach((key, index) => {
            if (!!key) {
                const defaultStyle = !!element.settings.slots ? element.settings.slots[index] : {};
                const bpStyle = defaultStyle?.responsiveConfig?.find(_config => _config.id === breakpoint) ?? {};

                let minHeight = '';
                if (!!bpStyle?.minHeight || !!defaultStyle.minHeight) {
                    minHeight = `min-height: ${bpStyle?.minHeight ?? defaultStyle.minHeight ?? 'fit-content'};`;
                }

                let height = '';

                const fullHeight = layout === 'layout-vertical-slider' ? '100dvh' : '100vh';

                if (!!bpStyle?.height || !!defaultStyle.height) {
                    let bpHeight = bpStyle?.height;
                    if (bpHeight === '100vh') {
                        bpHeight = 'calc(' + fullHeight + ' - var(--offset-body, 0))';
                    }
                    let defaultHeight = defaultStyle?.height;
                    if (defaultHeight === '100vh') {
                        defaultHeight = 'calc(' + fullHeight + ' - var(--offset-body, 0))';
                    }
                    height = `height: ${bpHeight ?? defaultHeight ?? 'auto'};`;
                }

                cssChilds.push(`
                #slot-${key.split('-')[0]}{
                    display: ${(structure[index] ?? '1').toString() !== '0' ? 'flex' : 'none'};
                    flex-grow: ${bpStyle?.flexGrow ?? defaultStyle.flexGrow ?? '0'};
                    flex-shrink: ${bpStyle?.flexShrink ?? defaultStyle.flexShrink ?? '1'};
                    flex-basis: ${bpStyle?.flexBasis ?? defaultStyle.flexBasis ?? 'auto'};
                    width: ${bpStyle?.width ?? defaultStyle.width ?? '100%'};
                    ${height}
                    ${minHeight}
                    max-height: ${bpStyle?.maxHeight ?? defaultStyle.maxHeight ?? 'none'};
                    min-width: ${bpStyle?.minWidth ?? defaultStyle.minWidth ?? 'auto'};
                    max-width: ${bpStyle?.maxWidth ?? defaultStyle.maxWidth ?? 'none'};
                    overflow: ${bpStyle?.overflow ?? defaultStyle.overflow ?? 'visible'};
                }
            `);
            }
        });
        return cssChilds.join('');
    }

    public static toFlex(value: string): string {
        switch (value) {
            case 'start':
                return 'flex-start';
            case 'end':
                return 'flex-end';
            case 'spaceBetween':
                return 'space-between';
            case 'spaceAround':
                return 'space-around';
            case 'spaceEvenly':
                return 'space-evenly';
            default:
                return value;
        }
    }
}
